export default __webpack_public_path__ + "static/media/forestly-expl-nn-04_EN.0cf4b5e3.png";